<template>
  <div class="progress-popup" ref="myElement">
    <div class="top">
      <v-icon @click="closeProgress">mdi-close</v-icon>
    </div>
    <div class="header">
      <h3>Your progress</h3>
      <span>Jan - Oct 2026</span>
    </div>
    <la-cartesian
      class="graph"
      :width="elementWidth + 6"
      :data="parsedProgress"
      :height="232"
      :bound="[0, n => n + 100]" 
      textColor="white"
      color="white">
      <defs>
        <linearGradient id="area-fill" x1="0" y1="0" x2="0" y2="1">
          <stop stop-color="#8BDF06" offset="0%" stop-opacity="0.2"></stop>
          <stop stop-color="#8BDF06" offset="50%" stop-opacity="0.1"></stop>
          <stop stop-color="#8BDF06" offset="100%" stop-opacity="0"></stop>
        </linearGradient>
      </defs>
      <la-x-axis prop="date" gridline dashed color="white"></la-x-axis>
      <la-area fill-color="url(#area-fill)" dot curve prop="value" color="#8BDF06">
        <g
        slot-scope="props"
        :fill="props.color">
        <circle
          :x="props.x - 5"
          :y="props.y - 5"
          width="10"
          height="10">
        </circle>
        <text
          :x="props.x"
          :y="props.y"
          text-anchor='middle'
          fill="white"
          dy="-.5em"
          v-if="!isNaN(props.value)"
         >
          {{ props.value }}
        </text>
      </g>
      </la-area>
    </la-cartesian>
  </div>
</template>

<script>
import { Cartesian, Area } from 'laue'
import moment from 'moment';
export default {
  components: {
    LaCartesian: Cartesian,
    LaArea: Area,
  },
  data() {
    return {
      elementWidth: 0
    }
  },
  props: {
    progress: {
      type: Array,
    },
    unit: {
      type: String
    }
  },
  computed: {
    parsedProgress() {
      let p
      if (this.unit === 'mins') {
        p = this.progress.map(x => {
          const indexOfMin = x.value.indexOf('m')
          const indexOfSec = x.value.indexOf('s')
          const min = x.value.substring(0, indexOfMin)
          const sec = x.value.substring(indexOfMin + 1, indexOfSec)
          return {date: moment(x.date, 'ddd MMM DD YYYY HH:mm:ss Z+HHmm').format('MMM'), value: ((parseInt(min)*60 + parseInt(sec)) / 60).toFixed(2) }
        })
      } else {
        p = this.progress.map(x => {
          return { date: moment(x.date, 'ddd MMM DD YYYY HH:mm:ss Z+HHmm').format('MMM'), value: x.value }
        })
      }
      return p
    },
  },
  methods: {
    closeProgress() {
      this.value = null
      this.$emit('close-progress')
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    }
  },
  mounted() {
    this.observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        this.elementWidth = entry.contentRect.width;
      }
    });
    // Assuming you have a ref on the element you want to observe
    if (this.$refs.myElement) {
      this.observer.observe(this.$refs.myElement);
    }
  },
  beforeDestroy() {
    this.observer.disconnect();
  },
}
</script>

<style scoped lang="scss">
.progress-popup {
  background: #100F0F;
  height: fit-content;
  padding: 32px;
  display: flex;
  flex-flow: column;

  .top {
    display: flex;
    justify-content: end;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 32px 0;
    h3 {
      font-size: 22px;
      font-weight: 700;
    }
    span {
      font-weight: 600;
      font-size: 16px;
    }
  }

  .graph {
    min-width: 100% !important;
    font-size: 14px !important;
    ::v-deep(svg) {
      overflow: visible !important;
    }
    ::v-deep(text) {
      transform: translateY(-10px);
    }
    ::v-deep(g) {
      &:nth-of-type(2) {
        g {
          transform: translateY(6px)
        }
      }
    }
  }
}
</style>